import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { getInventoryTransactionTypes } from "../../../api/inventoryService";

const TransactionTypeSelect = ({ typeId = "", value, onChange, label = "Select Type", ...props }) => {

    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await getInventoryTransactionTypes();
            setTypes(response);
            } catch (error) {
                console.error("Error fetching types:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [typeId]);

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      {loading ? (
        null
      ) : (
        <Select value={value} onChange={onChange} label={label}>
          {types.data.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default TransactionTypeSelect;